export type OrderedItem = {
  order?: number
}

export const DEFAULT_ORDER_GAP = 1_000_000_000

export const getNewOrder = (items: OrderedItem[], toIndex: number, gap: number = DEFAULT_ORDER_GAP): number => {
  const unrounded = getUnroundedOrder(items, toIndex, gap)
  return Math.round(unrounded)
}

const getUnroundedOrder = (items: OrderedItem[], toIndex: number, gap: number): number => {
  if (toIndex === 0) {
    const target = items.at(0)?.order ?? 0
    return target / 2
  }
  if (toIndex === items.length) {
    const target = items.at(items.length - 1)?.order ?? 0
    return target + gap
  }

  const smallTarget = items.at(toIndex - 1)?.order ?? 0
  const largeTarget = items.at(toIndex)?.order ?? gap

  return (smallTarget + largeTarget) / 2
}
